import { CODE_ENV_LIST, SMILE_TYPE, SMILE_TYPE_TEXT } from '@/common/constants/ConstCode';
import store from '@/store';
import { getCurrentPath, getImagePath, isEmpty, isIPad, isIPhone, isSafari } from '@/common/utils/Util';
import { nativeShareText } from '@/common/utils/module/NativeRequest';
import { showTextModal } from '@/common/utils/ModalState';

// TODO: 스마일 공유 구현
export const smileShare = () => {
  const smile = store.getters['smile/getDetail']; // 온라인 행사장 정보

  // let deadsForm = `고인 : ${deads.map(dead => dead.deadName).join(', ')}님`;

  let parsingName = '';

  if (smile.category === SMILE_TYPE.WEDDING.key) {
    parsingName = smile.firstName + ' ♥ ' + smile.secondName;
  } else if (smile.secondName) {
    parsingName = smile.firstName + ', ' + smile.secondName;
  } else {
    parsingName = smile.firstName;
  }

  let parsingTitle =
    smile.category === SMILE_TYPE.HUNDRED.key || smile.category === SMILE_TYPE.OLDER.key
      ? smile.type + '잔치'
      : SMILE_TYPE_TEXT[smile.category].name;

  const form = `[Life END Life] \n\n${parsingName}님의 온라인 ${parsingTitle}에 초대합니다. \n링크 : ${
    CODE_ENV_LIST.DYNAMIC_DOMAIN
  }/${getCurrentPath()}`;

  nativeShareText(form);
  navigator.clipboard.writeText(form).then(() => {
    if (!isIPhone() && !isIPad()) {
      showTextModal('현재 스마일 내용이 복사되었습니다.', '확인');
    }
  });
};

export const smileKakaoShare = () => {
  const smile = store.getters['smile/getDetail']; // 부고장 정보

  let parsingName =
    smile.category === SMILE_TYPE.WEDDING.key ? smile.firstName + ' ♥ ' + smile.secondName : smile.firstName;

  let parsingTitle =
    smile.category === SMILE_TYPE.HUNDRED.key || smile.category === SMILE_TYPE.OLDER.key
      ? smile.type + '잔치'
      : SMILE_TYPE_TEXT[smile.category].name;

  Kakao.Share.createDefaultButton({
    container: '#kakaotalk-sharing-btn',
    objectType: 'feed',
    content: {
      title: `${parsingName}님의 온라인 ${parsingTitle}에 초대합니다.`,
      imageUrl: isEmpty(smile?.hostImageInfo)
        ? `${CODE_ENV_LIST.FILE_SERVER_URL}/origin/AppIcon.png?v=2`
        : getImagePath(smile?.hostImageInfo?.storedFileName),
      link: {
        webUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/smile/event/info/hall/${smile.smileNo}`,
        mobileWebUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/smile/event/info/hall/${smile.smileNo}`
      }
    },
    itemContent: {
      profileText: 'Life END Life',
      profileImageUrl: `${CODE_ENV_LIST.FILE_SERVER_URL}/origin/AppIcon.png?v=2`
    },
    buttons: [
      {
        title: '확인하기',
        link: {
          webUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/smile/event/info/hall/${smile.smileNo}`,
          mobileWebUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/smile/event/info/hall/${smile.smileNo}`
        }
      }
    ]
  });
};

export const invitationShare = () => {
  const invitation = store.getters['invitation/getDetail']; // 온라인 초대장

  // let deadsForm = `고인 : ${deads.map(dead => dead.deadName).join(', ')}님`;

  let parsingName =
    invitation.category === SMILE_TYPE.WEDDING.key
      ? invitation.firstName + ' ♥ ' + invitation.secondName
      : invitation.firstName;

  let parsingTitle =
    invitation.category === SMILE_TYPE.HUNDRED.key || invitation.category === SMILE_TYPE.OLDER.key
      ? invitation.type + '잔치'
      : SMILE_TYPE_TEXT[invitation.category].name;

  let parsingAddress = '';

  if (!invitation.address && !invitation.addressDetail) {
    parsingAddress = '';
  } else {
    if (invitation.address) parsingAddress += `\n행사장 주소 : ${invitation.address}`;
    if (invitation.addressDetail) parsingAddress += ` ${invitation.addressDetail}`;
  }

  const form = `[Life END Life] \n${parsingName}님의 ${parsingTitle}(장소)를 알려드립니다
  \n링크 : ${CODE_ENV_LIST.DYNAMIC_DOMAIN}/${getCurrentPath()}`;

  nativeShareText(form);
  navigator.clipboard.writeText(form).then(() => {
    if (!isIPhone() && !isIPad()) {
      showTextModal('현재 함께하기 내용이 복사되었습니다.', '확인');
    }
  });
};

export const invitationKakaoShare = () => {
  const invitation = store.getters['invitation/getDetail']; // 부고장 정보

  let parsingName =
    invitation.category === SMILE_TYPE.WEDDING.key
      ? invitation.firstName + ' ♥ ' + invitation.secondName
      : invitation.firstName;

  let parsingTitle =
    invitation.category === SMILE_TYPE.HUNDRED.key || invitation.category === SMILE_TYPE.OLDER.key
      ? invitation.type + '잔치'
      : SMILE_TYPE_TEXT[invitation.category].name;

  Kakao.Share.createDefaultButton({
    container: '#kakaotalk-sharing-btn',
    objectType: 'feed',
    content: {
      title: `[Life END Life] \n${parsingName}님의 ${parsingTitle}(장소)를 알려드립니다`,
      imageUrl: isEmpty(invitation?.hostImageInfo)
        ? `${CODE_ENV_LIST.FILE_SERVER_URL}/origin/AppIcon.png?v=2`
        : getImagePath(invitation?.hostImageInfo?.storedFileName),
      link: {
        webUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/smile/invitation/info/${invitation.invitationNo}`,
        mobileWebUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/smile/invitation/info/${invitation.invitationNo}`
      }
    },
    itemContent: {
      profileText: 'Life END Life',
      profileImageUrl: `${CODE_ENV_LIST.FILE_SERVER_URL}/origin/AppIcon.png?v=2`
    },
    buttons: [
      {
        title: '확인하기',
        link: {
          webUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/smile/invitation/info/${invitation.invitationNo}`,
          mobileWebUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/smile/invitation/info/${invitation.invitationNo}`
        }
      }
    ]
  });
};
